<app-breadcrumbs [title]="'SITEMAP.GENERATE'" [first]="'SITEMAP.GENERATE' | translate"></app-breadcrumbs>

<div class="row">
    <div class="col-12 col-md-6">
        <dx-button class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="check" [disabled]="loadingService.unfinishedRequests || authService.hasAnyRole('SUPERADMIN', 'ACTUATOR')" [text]="'SITEMAP.GENERATE' | translate" type="success" (onClick)="generateSitemap()"></dx-button>
    </div>
</div>